var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Ajax from '@utils/ajax';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { useMutation } from '@tanstack/react-query';
import { isError } from '@src/utils';
export var name = 'session';
/** 用户登录 */
export var Login = createAsyncThunk(name + "/login", function (arg, _thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Ajax({
                    // api: `post ${__PERSONAL_API__}/user/v1/login`,
                    api: "post " + __PERSONAL_API__ + "/user/login",
                    headers: {
                        domain: window.location.origin,
                    },
                    parameter: arg,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); });
export var Logout = createAsyncThunk(name + "/logout", function (arg, _thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Ajax({
                    api: "get " + __PERSONAL_API__ + "/user/logout",
                    parameter: arg,
                    headers: {
                        'jwt-token': sessionStorage.getItem('token'),
                    },
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); });
/** 获取当前登录用户信息 */
export var Fetch = createAsyncThunk(name + "/fetch", function (arg, _thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Ajax({
                    // api: `get ${__PERSONAL_API__}/user/v1/info`,
                    api: "get " + __PERSONAL_API__ + "/user/info",
                    parameter: arg,
                    headers: {
                        domain: window.location.origin,
                        'jwt-token': sessionStorage.getItem('token'),
                    },
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); });
/** 判断是否展示AD */
export var isScreen = createAsyncThunk(name + "/is-screen", function (arg, _thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Ajax({
                    api: __PERSONAL_API__ + "/config/portal",
                    parameter: arg,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); });
/** 发送验证码 */
export var PostCaptcha = createAsyncThunk(name + "/post-captcha", function (arg, _thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Ajax({
                    api: "post " + __PERSONAL_API__ + "/user/sms",
                    parameter: arg,
                    headers: {
                        'jwt-token': arg.token,
                    },
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); });
export var VerifyCaptcha = createAsyncThunk(name + "/verify-captcha", function (arg, _thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Ajax({
                    api: "post " + __PERSONAL_API__ + "/user/sms/verification",
                    parameter: arg,
                    headers: {
                        'jwt-token': arg.token,
                    },
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); });
/** 重置密码 */
export function useResetPassword() {
    var _this = this;
    return useMutation([name + "/reset-password"], function (params) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Ajax({
                            api: "put " + __PERSONAL_API__ + "/user/pwd/reset",
                            parameter: params,
                            headers: { 'jwt-token': params.token },
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_1 = _a.sent();
                    throw isError(error_1) ? error_1.message : error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
export function UseUpdatePassword() {
    var _this = this;
    return useMutation([name + "/update-password"], function (params) { return __awaiter(_this, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Ajax({
                            api: "put " + __PERSONAL_API__ + "/user/pwd",
                            parameter: params,
                            headers: {
                                'jwt-token': params.token,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_2 = _a.sent();
                    throw isError(error_2) ? error_2.message : error_2;
                case 3: return [2 /*return*/];
            }
        });
    }); });
}
